import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IAccessories } from '@common-modules/product-catalogue';
import { mapAccessories } from '../../helpers/accessory';
import { updateAccessories } from '../../helpers/productDetails';
import { Accessory } from '../../types/accessory.types';
import { getUIAMEnabledWithToken } from '../../selectors';
import { AppState, KeyValue } from '../../types/common.types';

export const useAccessories = ({
  recommendedAccessories = [],
  accessories = [],
  abTestMtposCacheApiPending,
  isMTPOSStockCacheEnabled,
  abTestingPending
}: {
  recommendedAccessories: string[];
  accessories: Accessory[];
  abTestMtposCacheApiPending: boolean;
  isMTPOSStockCacheEnabled: boolean;
  abTestingPending?: boolean;
}) => {
  const [formattedAccessories, setFormattedAccessories] = useState<
    IAccessories[] | undefined
  >();

  const { apigeeTokenEnabled, selectedAccessories } = useSelector<
    AppState,
    KeyValue
  >(state => {
    return {
      apigeeTokenEnabled: getUIAMEnabledWithToken(state),
      selectedAccessories: state.accessory?.selectedAccessories
    };
  });

  useEffect(() => {
    if (abTestingPending === true) return;
    const setAccessories = async () => {
      let formattedAccessories = await mapAccessories(
        recommendedAccessories,
        accessories,
        isMTPOSStockCacheEnabled
      );
      if (selectedAccessories?.length) {
        formattedAccessories = updateAccessories(
          formattedAccessories,
          selectedAccessories
        );
      }
      setFormattedAccessories(formattedAccessories);
    };
    if (apigeeTokenEnabled && !abTestMtposCacheApiPending) {
      setAccessories();
    }
  }, [
    apigeeTokenEnabled,
    abTestMtposCacheApiPending,
    isMTPOSStockCacheEnabled,
    abTestingPending
  ]);

  useEffect(() => {
    const updatedAccessories = updateAccessories(
      formattedAccessories,
      selectedAccessories
    );
    if (updatedAccessories) {
      setFormattedAccessories(updatedAccessories);
    }
  }, [selectedAccessories]);

  return {
    formattedAccessories,
    selectedAccessories
  };
};
